import {Component, HostListener, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule, ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {TableColumn} from '../../../interfaces/table.interface';
import {MatOptionModule} from '@angular/material/core';
import {MatSelect, MatSelectModule} from '@angular/material/select';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';

@Component({
    selector: 'app-table-column-selection',
    templateUrl: './table-column-selection.component.html',
    styleUrls: ['./table-column-selection.component.scss'],
  standalone: true,
    imports: [
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    MatOptionModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule
]
})
export class TableColumnSelectionComponent implements OnInit {

  receivedData: any;
  tableColumns: TableColumn[];
  title = 'Table Column Selection';

  roleFilterCtrl: UntypedFormControl = new UntypedFormControl();
  @ViewChild('columnSelect', { static: true }) columnSelect: MatSelect;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog: MatDialog
  ) {
    this.receivedData = data;

    if (this.receivedData?.tableColumns?.length > 0){
      this.tableColumns = this.receivedData?.tableColumns;
    }

    if (this.receivedData?.extraTableColumns?.length > 0){
      this.tableColumns.push(this.receivedData?.extraTableColumns);
    }

    this.tableColumns = this.tableColumns.map( tableColumn => {
      return {
        ...tableColumn,
        title: tableColumn?.isActionColumn ? 'Action Column' : tableColumn?.title
      };
    });
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    this.dialog.closeAll();
  }

  ngOnInit(): void {
  }

  onSearch(searchValue) {
    this.tableColumns = this.tableColumns?.filter( (v) => v.title?.toLowerCase().indexOf(searchValue?.toLowerCase()) > -1);
  }

}
